<template>
    <div :class="{'form__row': !hidden}" v-if="withRow">
        <div class="row">
            <div class="col-lg-4 offset-lg-2">
                <div class="form-field" :class="{'form-field--error': hasError || parentError}" v-if="!hidden">
                    <label :for="name" class="form-field__label">{{label}}<span class="form-field__optional" v-if="isOptional"> {{optional}}</span></label>
                    <div class="form-field__input-container">
                        <input :id="name"
                               :type="type"
                               class="form-field__input"
                               :name="name"
                               :required="!isOptional"
                               v-model="inputValue"
                               @focus="focus()"
                               @blur="unfocus()"
                               @input="validateValue($event.target.value)"
                               v-validate="rules">
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="form-field" :class="{'form-field--hidden': hidden, 'form-field--error': hasError || parentError}" v-else-if="!hidden">
        <label :for="name" class="form-field__label">{{label}}<span class="form-field__optional" v-if="isOptional"> {{optional}}</span></label>
        <div class="form-field__input-container">
            <input :id="name"
                   :type="type"
                   class="form-field__input"
                   :name="name"
                   :required="!isOptional"
                   v-model="inputValue"
                   @focus="focus()"
                   @blur="unfocus()"
                   @input="validateValue($event.target.value)"
                   v-validate="rules">
        </div>
    </div>
</template>
<script>
    import {mapGetters} from 'vuex'

    export default {
        props: {
            label: String,
            name: String,
            type: String,
            conditionName: String,
            conditionValue: String,
            validation: String,
            value: String,
            optional: {
                type: String,
                default: ''
            },
            withRow: {
                type: Boolean,
                default: false
            },
            parentError: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                focused: false,
                needsValidate: false,
                hasError: false,
                inputValue: ''
            }
        },
        computed: {
            ...mapGetters('form', [
                'entries'
            ]),
            isOptional: function() {
                return this.optional !== '';
            },
            hidden: function () {
                return this.conditionName && this.conditionValue
                    && this.entries[this.conditionName] !== this.conditionValue;
            },
            rules: function() {
                return this.validation === '' ? false : this.validation;
            }
        },
        watch: {
            hasError: function() {
                this.needsValidate = true;
            },
            value: function(value) {
                this.inputValue = value;
            }
        },
        methods: {
            validate: function() {
                return this.$validator.validate().then((result) => {
                    this.hasError = !result;

                    return result;
                });
            },
            focus: function() {
                this.focused = true;
            },
            unfocus: function() {
                this.validate();
            },
            validateValue: function(value) {
                if (this.needsValidate) {
                    this.validate();
                }

                this.$emit('input', value);
            }
        },
        mounted: function() {
            this.inputValue = this.value;
        }
    }
</script>